import { render } from "./TermsOfServicePage.vue?vue&type=template&id=b749da9a"
import script from "./TermsOfServicePage.vue?vue&type=script&lang=js"
export * from "./TermsOfServicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__